/** @file firstDrawable: the id of the first drawable a node carries (what "Open drawable in Art" shows). */
import type { EditorStore } from '../../state/editorTypes';

/** The first drawable of `node`, or null (also when no puppet is open). */
export function firstDrawable(store: EditorStore, node: string): string | null {
  return store.getState().puppet.doc?.puppet.drawables.find((d) => d.node === node)?.id ?? null;
}
